import { DbItem } from '../interfaces/definitions/db-item.interface'
import { Product } from '../interfaces/definitions/product.interface'
import { User } from '../interfaces/definitions/user.interface'

interface CognitoUser {
  Attributes: any[]
  Enabled: boolean
  UserCreateDate: string
  UserLastModifiedDate: string
  UserStatus: string
  Username: string
  isAdmin: boolean
}

export async function mapResponse (response: any): Promise<Product | Product[]> {
  try {
    const result = await response.body.json()

    if (Array.isArray(result)) {
      return result.map(mapProductResponse)
    }

    return mapProductResponse(result)
  } catch (error) {
    console.log('🚀 ~ mapResponse ~ error:', error)
    throw error
  }
}

export function mapProductResponse (product: DbItem): Product {
  const data = JSON.parse(product.Data) as Omit<Product, 'id'>

  return {
    id: product.PK,
    ...data
  }
}

export async function mapResponseForUsers (response: any): Promise<User[]> {
  try {
    const result = await response.body.json()
    return result.map(mapProductResponseForUsers)
  } catch (error) {
    console.log('🚀 ~ mapResponse ~ error:', error)
    throw error
  }
}

export function mapProductResponseForUsers (user: CognitoUser): User {
  const { Attributes, UserStatus } = user
  return {
    username: Attributes.find((attr) => attr.Name === 'email')?.Value,
    role: Attributes.find((attr) => attr.Name === 'custom:role')?.Value,
    id: Attributes.find((attr) => attr.Name === 'email')?.Value,
    userStatus: UserStatus,
    password: '',
    admin: user.isAdmin
  }
}
